import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_2 = { class: "w-11/12 pt-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-lg pt-2 flex items-center"
}
const _hoisted_4 = { class: "pb-4" }
const _hoisted_5 = { class: "w-1/12 justify-self-end" }
const _hoisted_6 = { class: "flex justify-end" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_close = _resolveComponent("icon-close")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["relative w-auto h-auto max-h-40 p-2 pl-6 pr-4 rounded text-sm flex items-center", _ctx.classes]
          }, [
            _hoisted_1,
            _createVNode("div", _hoisted_2, [
              (_ctx.title)
                ? (_openBlock(), _createBlock("h1", _hoisted_3, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.variant), { class: "mr-2" })),
                    _createTextVNode(" " + _toDisplayString(_ctx.title), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_icon_close, {
                  class: "cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:modelValue', false)))
                })
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}